/** @format */

import { makeStyles } from '@material-ui/core';
import React from 'react';
import adescomStyle from '../../../../assets/jss/adescom/adescomStyle';
import InputFormRest from '../../../../components/Form/InputFormRest';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import { FormGeneralHelper } from '../../../../helpers/FormGeneral';
import RateSchemaInterface from '../../../../interfaces/billing/RateSchemaInterface';
import CustomInputExtNumber from '../../../../components/CustomInput/CustomInputExtNumber';

interface RateServiceProps {
    tmp?: string;
    changeRateInput: (e: any, stateName: string) => void;
    rateEntity: RateSchemaInterface;
    rateEntityStatus: any;
}

export const RateService = (props: RateServiceProps): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const { changeRateInput, rateEntity, rateEntityStatus } = props;

    return (
        <GridContainer>
            <GridItem xs={9}>
                <GridContainer>
                    <GridItem xs={5}>
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="interval1"
                            stateObjectState={rateEntityStatus.interval1}
                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                            typeField={FormGeneralHelper.TYPE_TEXT}
                            displayFieldName="pricelists:h.interval1"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.interval1}
                        />
                        <CustomInputExtNumber
                            onChange={changeRateInput}
                            name="price1"
                            labelText="pricelists:h.price1"
                            required={true}
                            value={rateEntity.price1}
                            decimalLimit={10}
                        />
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="duration1"
                            stateObjectState={rateEntityStatus.duration1}
                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                            typeField={FormGeneralHelper.TYPE_TEXT}
                            displayFieldName="pricelists:h.duration1"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.duration1}
                        />
                    </GridItem>
                    <GridItem xs={2}></GridItem>
                    <GridItem xs={5}>
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="interval2"
                            stateObjectState={rateEntityStatus.interval2}
                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                            typeField={FormGeneralHelper.TYPE_TEXT}
                            displayFieldName="pricelists:h.interval2"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.interval2}
                        />
                        <CustomInputExtNumber
                            onChange={changeRateInput}
                            name="price2"
                            labelText="pricelists:h.price2"
                            required={true}
                            value={rateEntity.price2}
                            decimalLimit={10}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
